module.exports = __webpack_public_path__ + "static/media/bustaxitrain.04a65e54.webp";